module.exports = __webpack_public_path__ + "img/iss_world.96c66109.jpg";